






































































import { Component, Vue } from "vue-property-decorator";
import IndividualTaxationService from "@/services/request/IndividualTaxationService";
import TaxReturnFilter from "@/dto/payroll/TaxReturnFilter";
import IncomeTaxReturnDocumentDTO from "@/dto/payroll/IncomeTaxReturnDocumentDTO";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import RouteNames from "@/router/RouteNames";
import PortalInput from "@/components/common/PortalInput.vue";
import {debounce} from "typescript-debounce-decorator";

@Component({
  components: { PaginationComponent, PortalInput }
})
export default class IndividualTaxReturns extends Vue {
  public RouteNames = RouteNames;
  public returns: any[] = [];
  public totalPages = 0;
  public filter: TaxReturnFilter = {
    page: 0,
    size: 20,
    customerName: "",
    customerEmail: "",
    year: "",
    noSubmissionId: false
  };

  mounted() {
    this.loadData();
  }

  @debounce(200)
  public loadData() {
    IndividualTaxationService.getTaxReturns(this.filter).then(ok => {
      this.returns = ok.data.content;
      this.totalPages = ok.data.totalPages;
    });
  }

  public clearFilter() {
    this.filter = {
      page: 0,
      size: 20,
      customerName: "",
      customerEmail: "",
      year: "",
      noSubmissionId: false
    };
    this.loadData();
  }

  public changePage(page: number) {
    this.filter.page = page - 1;
    this.loadData();
  }
}
